import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SectionHead({ title, sub, level = 2 }) {
    const Heading = `h${level}`;
    return (_jsxs("div", { className: "sechead", children: [_jsx("span", { className: "mk", "aria-hidden": "true", children: "\u00A7" }), _jsx(Heading, { children: title }), sub && _jsx("span", { className: "sub", children: sub })] }));
}
//# sourceMappingURL=SectionHead.js.map